import { useState } from 'react';
import Button from '../../../components/base/Button';
import BookingCalendar from '../../../components/feature/BookingCalendar';

export default function HeroSection() {
  const [isBookingOpen, setIsBookingOpen] = useState(false);

  const scrollToHowItWorks = () => {
    const element = document.getElementById('come-funziona');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openBookingCalendar = () => {
    setIsBookingOpen(true);
  };

  return (
    <>
      <section 
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('/images/hero-bg.jpg')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="text-center text-white">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
              Contratti di Locazione
              <span className="block text-blue-400">a norma di legge </span>
            </h1>
            <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed">
              Affidati ad un agente immobiliare esperto in locazioni per creare il tuo contratto di locazione personalizzato a norma di legge. 
               <p>Semplice, sicuro!</p>
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
              <Button 
                size="lg" 
                className="text-lg px-8 py-4"
                onClick={openBookingCalendar}
              >
                <i className="ri-video-chat-fill mr-2"></i>
                Consulenza Gratuita 15 min
              </Button>
              <Button 
                variant="outline" 
                size="lg" 
                className="text-lg px-8 py-4 border-white text-white hover:bg-white hover:text-gray-900"
                onClick={scrollToHowItWorks}
              >
                <i className="ri-phone-fill mr-2"></i>
                Scopri Come Funziona
              </Button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-8 max-w-5xl mx-auto">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
                <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-video-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-semibold mb-2">Videoconferenza gratuita</h3>
                <p className="text-gray-200">Incontro online per proporre il contratto più indicato alle tue esigenze. La distanza non è più un problema !</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
                <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-file-text-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-semibold mb-2">Contratto Su Misura</h3>
                <p className="text-gray-200">Contratto legale personalizzato a norma di legge, perfetto per le tue esigenze </p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
                <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-quill-pen-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-semibold mb-2">Firma a Distanza</h3>
                <p className="text-gray-200">Firma elettronica qualificata con pieno valore legale, semplice e sicura</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
                <div className="w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-semibold mb-2">Registrazione Agenzia Entrate</h3>
                <p className="text-gray-200">Servizio completo di registrazione contratto all'Agenzia delle Entrate</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <BookingCalendar 
        isOpen={isBookingOpen} 
        onClose={() => setIsBookingOpen(false)} 
      />
    </>
  );
}